/**
 * And you may find yourself in this file with deprecated constants and types
 * And you may ask yourself, "Well, how did I get here?"
 * And you may ask yourself, "Why does this file and constants/sortDirectionsEnum exist?"
 *
 * This file used to be a js file with flow typings that were imported by ts files,
 * and that somehow worked, despite being very problematic. And we don't like flow,
 * and got rid of it by removing all flow annotations (https://iterable.atlassian.net/browse/FE-818),
 * and the quickest way to do that for this file was to convert it to TS with very loose typings
 * so that the TS files that imported the old flow annotations don't complain.
 *
 * But we should not use these types going forward given that the other, more modern file exists instead.
 * So everything here is deprecated.
 *
 * Same as it ever was...
 */

/** @deprecated use the value from constants/sortDurectionsEnum instead */
export const ASCENDING = 'asc';

/** @deprecated use the value from constants/sortDurectionsEnum instead */
export const DESCENDING = 'desc';

// export type SortDirections = ASCENDING | DESCENDING;
/** @deprecated use the value from constants/sortDurectionsEnum instead */
export type SortDirections = string;
/** @deprecated use the value from constants/sortDurectionsEnum instead */
export type SortDirectionsUseState = [SortDirections, () => void];

/**
 GraphQL Enums for sorting with page info
 */
/** @deprecated use the value from constants/sortDurectionsEnum instead */
export const SORT_DIRECTIONS = {
  ASCENDING: 'Ascending',
  DESCENDING: 'Descending',
};

// Directions used in gql queries that include sorting
/** @deprecated use the value from constants/sortDurectionsEnum instead */
export type GqlSortDirections =
  | typeof SORT_DIRECTIONS.ASCENDING
  | typeof SORT_DIRECTIONS.DESCENDING;

/** @deprecated use the value from constants/sortDurectionsEnum instead */
export interface TableGqlSortDirectionMap {
  [key: GqlSortDirections | SortDirections]: GqlSortDirections | SortDirections;
}

/** @deprecated use the value from constants/sortDurectionsEnum instead
 * Maps our table sorting to gql sorting for queries
 *
 * EG: A table header is clicked, and you need to update the variable returned
 * by the callback into a graphQL friendly query.  Given that you're using the
 * `refresh` function provided by the `useQuery` hook, you can do:
 *
 * ```jsx
 * <TableHeader setSortDirection={dir => refresh({ sortDirection: TABLE_GQL_SORT_DIRECTION_MAP[dir] })} />
 * ```
 */
export const TABLE_GQL_SORT_DIRECTION_MAP: TableGqlSortDirectionMap = {
  [ASCENDING]: SORT_DIRECTIONS.ASCENDING,
  [DESCENDING]: SORT_DIRECTIONS.DESCENDING,
  [SORT_DIRECTIONS.ASCENDING]: ASCENDING,
  [SORT_DIRECTIONS.DESCENDING]: DESCENDING,
};
